import React from 'react';
import PropTypes from 'prop-types';

import InfoTooltip from 'components/InfoTooltip';

const RepaymentTypeTooltip = ({ color, hoverColor, position }) => (
  <InfoTooltip
    title="Repayment Type"
    tooltip={(
      <div className="md:w-[300px] whitespace-normal my-2">
        <p className="text-sm mb-2">Choose how you'd like to repay your loan. Please note that not all repayment types may always be offered.</p>

        <h5 className="font-semibold mb-1">Interest Only Option:</h5>
        <p className="text-sm mb-2">You'll make smaller fixed monthly payments that approximately cover only the interest. The loan principal and remaining interest are due in one lump sum payment at the end of the term.</p>

        <h5 className="font-semibold mb-1">No Monthly Payment Option:</h5>
        <p className="text-sm">You won't make any monthly payments until the end of your term. The full loan principal plus all accrued interest will be due in one lump sum payment at the end of the term.</p>
      </div>
    )}
    color={color}
    hoverColor={hoverColor}
    position={position}
  />
);

RepaymentTypeTooltip.propTypes = {
  color: PropTypes.string,
  hoverColor: PropTypes.string,
  position: PropTypes.oneOf(['top', 'bottom']),
};

RepaymentTypeTooltip.defaultProps = {
  color: 'gray-400',
  hoverColor: 'gray-600',
  position: 'top',
};

export default RepaymentTypeTooltip;
